/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LDAPServerGroup,
    LDAPServerGroupFromJSON,
    LDAPServerGroupFromJSONTyped,
    LDAPServerGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface LDAPServerGroups
 */
export interface LDAPServerGroups {
    /**
     * 
     * @type {Array<LDAPServerGroup>}
     * @memberof LDAPServerGroups
     */
    groups: Array<LDAPServerGroup>;
}

export function LDAPServerGroupsFromJSON(json: any): LDAPServerGroups {
    return LDAPServerGroupsFromJSONTyped(json, false);
}

export function LDAPServerGroupsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LDAPServerGroups {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groups': ((json['groups'] as Array<any>).map(LDAPServerGroupFromJSON)),
    };
}

export function LDAPServerGroupsToJSON(value?: LDAPServerGroups | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groups': ((value.groups as Array<any>).map(LDAPServerGroupToJSON)),
    };
}


